const OPERATION_SUCCESS = 'OPERATION_SUCCESS'
const OPERATION_FAIL = 'OPERATION_FAIL'

export { OPERATION_SUCCESS, OPERATION_FAIL }
